<template>
  <div class="login-container">
    <div class="backcloth">
      <img class="picA" src="../assets/images/gina.png" alt="" />
      <img class="picB" src="../assets/images/ginb.png" alt="" />
      <div class="topic">
        <span>欢迎来到</span>
        <span>芒果投放平台</span>
      </div>
    </div>
    <div class="content">
      <van-form @submit="onSubmit">
        <van-cell-group>
          <van-field
            v-model="username"
            name="username"
            placeholder="请输入用户名"
            :rules="[{ required: true, message: '请填写用户名' }]"
          />
          <van-field
            v-model="password"
            type="password"
            name="password"
            placeholder="请输入密码"
            :rules="[{ required: true, message: '请填写密码' }]"
          />
        </van-cell-group>
        <van-button round block type="info" native-type="submit">
          登录
        </van-button>
      </van-form>
    </div>
  </div>
</template>

<script>
import { base64Encrypt } from "@/utils/encrypt";
import { login } from "@/api/modules/home"; // 直接导入login方法


export default {
  name: "LoginPage",
  data() {
    return {
      username: "",
      password: "",
    };
  },
  methods: {
    async onSubmit() {
      try {
        const encryptedData = {
          username: base64Encrypt(this.username),
          password: base64Encrypt(this.password),
          __ajax: "json",
        };

        const response = await login(encryptedData); // 在请求配置中添加 loading: false
        if (response.result == "true") {
          await this.$store.dispatch("setUserInfo", {
            user: response.user.userName,
            role:
              response.roleList.length !== 0
                ? response.roleList[0].roleName
                : "",
            sessionid: response.sessionid,
          })
          // .then(() => {
          //   // 设置成功后的操作
          // })
          // .catch((error) => {
          //   console.error("设置用户信息失败:", error);
          // });

          this.$toast.success("登录成功");
          const redirect = this.$route.query.redirect || "/home";
          this.$router.replace(redirect);
        } else {
          throw new Error(response.message || "登录失败");
        }
      } catch (error) {
        this.$toast.fail(error.message || "登录失败，请重试");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.login-container {
  height: 100vh;
  background: #f7f8fa;
  display: flex;
  flex-direction: column;
  .backcloth {
    width: 100%;
    height: 202px;
    background: #002ea4;
    position: relative;
    img {
      position: absolute;
    }
    .picA {
      width: 324px;
      height: 324px;
      right: -110px;
      top: -115px;
    }
    .picB {
      width: 234px;
      height: 234px;
      left: -84px;
      top: 17px;
    }
    .topic {
      font-weight: 600;
      font-size: 20px;
      color: #ffffff;
      font-family: Inter;
      position: absolute;
      top: 59px;
      left: 15px;
      span {
        display: block;
      }
      span:first-child {
        margin-bottom: 12px;
      }
    }
  }
  .content {
    flex: 1;
    z-index: 1;
    margin-top: -50px;
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    padding: 0 15px;
    box-sizing: border-box;
    .van-form {
      margin-top: 42px;
      .van-cell {
        border-radius: 12px;
        border: 1px solid #c3c3c3;
        margin-bottom: 14px;
        .van-field__label {
          color: #8d8888;
          font-family: Inter;
          font-weight: 400;
          font-size: 16px;
          line-height: 100%;
        }
      }
      .van-button--round {
        width: 100%;
        height: 50px;
        background: #2575f2;
        border-radius: 12px;
        margin-top: 48px;
      }
    }
  }
}
</style>
